"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _highcharts = require("highcharts/highcharts");

var _highcharts2 = _interopRequireDefault(_highcharts);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SourceOfEnquiryChartController = function () {
    function SourceOfEnquiryChartController($scope) {
        "ngInject";

        //Begin Services

        var _this = this;

        (0, _classCallCheck3.default)(this, SourceOfEnquiryChartController);
        this.$scope = $scope;
        //End Services

        //Begin Data
        this.hasNoTarget = false;
        this.chartContainerId = "chartContainer" + this.getGuid();
        this.chart = null;
        //End Data

        //Begin Initialize
        this.$onChanges = function (changesObj) {
            if (changesObj.data && changesObj.data.currentValue) {
                _this.chart = _this.generateChart();
            } else {
                if (_this.chart) {
                    _this.chart.destroy();
                }
            }
        };
        //End Initialize 
    }

    (0, _createClass3.default)(SourceOfEnquiryChartController, [{
        key: "generateChart",
        value: function generateChart() {
            var _this2 = this;

            //Chart Code Start    
            var ctrl = this;

            var labels = [];
            var costSeries = [];
            var openSeries = [];
            var lostSeries = [];
            var confirmedSeries = [];
            var closedSeries = [];
            var conversionSeries = [];

            this.data.map(function (item) {
                var location = item[0];
                var source = item[1];

                var costPerEnquiry = _this2.toNumber(item[3]);
                var conversionRatio = _this2.toNumber(item[4]);

                var open = _this2.toNumber(item[5]);
                var lost = _this2.toNumber(item[6]);
                var confirmed = _this2.toNumber(item[7]);
                var closed = _this2.toNumber(item[8]);

                labels.push(location + "<br>" + source);
                costSeries.push(costPerEnquiry);
                openSeries.push(open);
                lostSeries.push(lost);
                confirmedSeries.push(confirmed);
                closedSeries.push(closed);
                conversionSeries.push(conversionRatio);
            });

            var chartOptions = {
                chart: {
                    type: 'column',
                    height: '300'
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: labels,
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: null
                    }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0,
                        stacking: 'normal'
                    }
                },
                series: [{
                    name: 'Conversion Ratio',
                    data: conversionSeries
                }, {
                    name: 'Cost per Enquiry (€)',
                    data: costSeries
                }, {
                    name: 'Open',
                    data: openSeries,
                    stack: 'count'
                }, {
                    name: 'Lost',
                    data: lostSeries,
                    stack: 'count'
                }, {
                    name: 'Confirmed',
                    data: confirmedSeries,
                    stack: 'count'
                }, {
                    name: 'Closed',
                    data: closedSeries,
                    stack: 'count'
                }]
            };

            return _highcharts2.default.chart(this.chartContainerId, chartOptions);

            //Chart Code End
        }
    }, {
        key: "getGuid",
        value: function getGuid() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }
    }, {
        key: "toNumber",
        value: function toNumber(currency) {
            if (currency) {
                return parseInt(currency.replace("€", ""));
            }

            return 0;
        }
    }]);
    return SourceOfEnquiryChartController;
}();

exports.default = SourceOfEnquiryChartController;


// WEBPACK FOOTER //
// ./client/app/components/reports/SourceOfEnquiry/sourceOfEnquiryChart/sourceOfEnquiryChart.controller.js